<script setup lang="ts">

import { FilterDateRange, FiltersBar } from '@shared/ui/filters'
import { AppInput } from '@shared/ui/inputs'
import { AppMultiSelect } from '@shared/ui/selects'

import { useFiltersSubscriptions } from '../model/filters-subscriptions.hook'

defineOptions({
  name: 'FiltersSubscriptions',
})

withDefaults(defineProps<{
  /** The customer's Subscriptions tab keeps the legacy "Search" placeholder in the date field. */
  isCustomerTab?: boolean
}>(), {
  isCustomerTab: false,
})

const {
  refSearch,
  refDateRange,
  refStatuses,
  statusOptions,
  isLoading,
  clearFilters,
  submitSearch,
} = useFiltersSubscriptions()
</script>

<template>
  <FiltersBar
    class="filters-subscriptions"
    :loading="isLoading"
    @click:submit="submitSearch"
    @click:clear="clearFilters"
  >
    <template #fields>
      <AppInput
        v-model="refSearch"
        class="filters-subscriptions__search"
        label="Search"
        placeholder="Search"
        :disabled="isLoading"
      />

      <AppMultiSelect
        v-model="refStatuses"
        class="filters-subscriptions__status"
        :options="statusOptions"
        label="Subscription status"
        placeholder="All"
        :disabled="isLoading"
        clearable
      />

      <FilterDateRange
        v-model="refDateRange"
        class="filters-subscriptions__date"
        label="Invoice date"
        :placeholder="isCustomerTab ? 'Search' : 'Select range'"
        :disabled="isLoading"
      />
    </template>
  </FiltersBar>
</template>

<style scoped lang="scss" src="./FiltersSubscriptions.scss" />
